const { DateTime, Interval } = require("luxon");

const { getSlots, INITIAL_DATE_TIME } = require("./util");
const { SLOT_BLOCK_REASON } = require("../constants");

function validateHour(hour, type) {
  let hourTest = null;
  if (
    isNaN(hour) ||
    (typeof hour === "string" && hour.length === 0) ||
    hour === null
  ) {
    if (type === "start") {
      hourTest = 0;
    } else if (type === "end") {
      hourTest = 24;
    }
  } else {
    hourTest = Number(hour);
  }
  return hourTest;
}

function isNotValidateHour(hour) {
  return (
    isNaN(hour) ||
    (typeof hour === "string" && hour.length === 0) ||
    hour === null
  );
}

function getStartTime(date, hours) {
  return date.set({
    ...INITIAL_DATE_TIME,
    hour: validateHour(hours, "start"),
  });
}

function getEndTime(date, hours) {
  return date.set({
    ...INITIAL_DATE_TIME,
    hour: validateHour(hours, "end"),
  });
}

function getDateTime(date, hours, type) {
  let dateTime = null;
  if (isNotValidateHour(hours)) {
    if (type === "start") {
      dateTme = date.startOf("day");
    } else if (type === "end") {
      dateTme = date.endOf("day");
    }
  } else {
    dateTime = date.set({
      ...INITIAL_DATE_TIME,
      hour: validateHour(hours, "end"),
    });
  }

  return dateTime;
}

function getScheduleForTheDay(hours, date, day) {
  let periods = [];
  if (hours[day][0].allDay) {
    const startTime = getStartTime(date, 0);
    const endTime = getEndTime(date, 24);
    const schedule = {
      ...hours[day][0],
      openDay: day,
      closeDay: day,
      startTime,
      endTime,
      startHour: 0,
      endHour: 24,
    };
    periods.push(schedule);
  } else {
    let newSchedule = Object.values(hours);
    newSchedule.forEach((arr) => {
      if (typeof arr[Symbol.iterator] === "function") {
        periods.push(...arr);
      }
    });

    periods = periods.filter(
      (period) => period.openDay === day || period.closeDay === day
    );

    periods = periods.map((period) => {
      let startTime = null;
      let endTime = null;

      if (period.openDay === day) {
        startTime = getDateTime(date, period.startTime, "start");
        // startTime = getStartTime(date, period.startTime);
      } else {
        const startOfDay = date.plus({ days: -1 });
        startTime = getDateTime(startOfDay, period.startTime, "start");
        // startTime = getStartTime(startOfDay, period.startTime);
      }

      if (period.closeDay === day) {
        endTime = getDateTime(date, period.endTime, "end");
        // endTime = getEndTime(date, period.endTime);
      } else {
        const startOfDay = date.plus({ days: 1 });
        endTime = getDateTime(startOfDay, period.endTime, "end");
        // endTime = getEndTime(startOfDay, period.endTime);
      }
      return {
        ...period,
        startTime,
        endTime,
      };
    });
  }
  return periods;
}

function getSchedule(hours, date) {
  if (!hours) return [];
  const theDate = DateTime.fromJSDate(date);
  const day = theDate.toFormat("cccc");
  return getScheduleForTheDay(hours, theDate, day);
}

function slotSort(a, b) {
  return a.start > b.start
    ? 1
    : a.start.toMillis() === b.start.toMillis()
    ? a.start > b.start
      ? 1
      : -1
    : -1;
}

function getInterval(startTime, duration, endTime) {
  const start = startTime;
  const end = endTime
    ? endTime
    : start.plus({
        minutes: duration,
      });

  return Interval.fromDateTimes(start, end);
}

function getScheduleSlots(startTime, endTime, interval = 30) {
  let start = startTime;
  const end = endTime;
  const slots = [];
  while (start < end) {
    const slotEnd = start.plus({ minute: interval });
    if (slotEnd > end) break;
    slots.push({ start, end: slotEnd, available: true });

    start = slotEnd;
  }
  return slots;
}

function mergeSlots(slots, schedule, interval) {
  let scheduleSlots = schedule.map((slot) => {
    return getScheduleSlots(slot.startTime, slot.endTime, interval);
  });
  scheduleSlots = scheduleSlots.reduce(
    (accumulator, currentValue) => accumulator.concat(currentValue),
    []
  );
  scheduleSlots = scheduleSlots.map((slot) => ({ ...slot, available: true }));

  let newSlots = slots.filter((slot) => slot.available === false);

  return [...newSlots, ...scheduleSlots];
}

function getSlotsBySchedule(slots, schedule) {
  return slots.map((slot) => {
    const slotInterval = getInterval(slot.start, null, slot.end);
    let available = schedule.some((scheduleSlot) => {
      const scheduleSlotInterval = getInterval(
        scheduleSlot.startTime,
        null,
        scheduleSlot.endTime
      );
      const engulfs = scheduleSlotInterval.engulfs(slotInterval);
      return engulfs;
    });
    const reason = available ? null : SLOT_BLOCK_REASON.CLOSED;
    return { ...slot, available, ...(reason && { reason }) };
  });
}

const intervalsStrings = [
  { key: "15 Min", value: 15 },
  { key: "30 Min", value: 30 },
  { key: "1 Hour", value: 60 },
  { key: "2 Hours", value: 120 },
  { key: "2.5 Hours", value: 150 },
];

function getSettingsInterval(int) {
  let interval = null;
  if (typeof int === "string") {
    interval = intervalsStrings.filter((interval) => interval.key === int)[0]
      .value;
  } else {
    interval = int;
  }
  return interval;
}

module.exports = function getScheduledSlots(business, date) {
  if (business || business.settings) {
    const interval = getSettingsInterval(
      business.settings.reservationIntervals
    );
    const hours = business.settings.reservationAvailableHours;
    const schedule = getSchedule(hours, date);
    let slots = getSlots(0, 24, 15, date);
    slots = getSlotsBySchedule(slots, schedule);
    slots = mergeSlots(slots, schedule, interval);
    slots.sort(slotSort);
    return slots;
  }
  return null;
};
